export default __webpack_public_path__ + "static/media/flag_se.b06f1923.webp";